// istanbul ignore file
import styled, { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { typography } from '@clds/typography';
import Button from '@cld/button';
import { t } from './EmptyTransformationManagerCardTheme';

const flexChildMargin = css`
  margin: 0 auto ${t.child.margin};
`;

export const Root = styled.div`
  width: ${t.width};
  background-color: ${t.background};
  border-radius: ${t.border.radius};
  text-align: center;
  margin: auto;
  display: flex;
  flex-direction: column;
  padding: ${t.padding.vertical} 0;

  ${Button} {
    margin: 0 auto;
  }
`;

export const BackgroundImage = styled.div`
  height: ${t.image.height};
  width: 100%;
  background: url(${t.image.url}) center center no-repeat;
  background-size: contain;
  ${flexChildMargin};
`;

export const Header = styled.div`
  ${flexChildMargin};
  ${typography.xxl.contrastInvert};
  color: ${globalTheme.color.white};
`;
